<template>
  <PaymentPanel
    class="mb-8"
    :title="$t('payment.officer_title')"
    :student_id="selected_student_id"
    editable
  >
    <template v-slot:controls>
      <v-card-text class="payment-officer-controls px-4 pt-0 pb-1 mt-n2">
        <v-form
          ref="studentForm"
          v-model="valid"
          @submit.prevent="search_student"
        >
          <v-row dense align="start" justify="center" class="my-0">
            <v-col cols="12" sm="7" class="student-id-search-col py-1">
              <v-text-field
                v-model="input_student_id"
                :label="$t('home.student_id')"
                :rules="student_id_rules"
                counter="8"
                maxlength="8"
                inputmode="numeric"
                outlined
                dense
                hide-details="auto"
                required
                @input="keep_only_digits"
              />
            </v-col>
            <v-col cols="12" sm="auto" class="py-1">
              <v-btn
                color="primary"
                depressed
                height="40"
                type="submit"
                :disabled="!can_search"
              >
                <v-icon left>mdi-magnify</v-icon>
                {{ $t("payment.search") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </template>
  </PaymentPanel>
</template>

<script>
import PaymentPanel from "./components/PaymentPanel.vue";

function normalize_student_id(value) {
  const studentId = String(value || "").trim();
  return /^\d{8}$/.test(studentId) ? studentId : "";
}

function get_student_id_from_url() {
  if (typeof window === "undefined") return "";

  const hashQuery = String(window.location.hash || "").split("?")[1] || "";
  const hashStudentId = new URLSearchParams(hashQuery).get("student_id");
  const searchStudentId = new URLSearchParams(
    window.location.search || ""
  ).get("student_id");
  return normalize_student_id(hashStudentId || searchStudentId);
}

export default {
  name: "payment_officer",
  components: {
    PaymentPanel,
  },
  data() {
    const initialStudentId = get_student_id_from_url();
    return {
      valid: Boolean(initialStudentId),
      input_student_id: initialStudentId,
      selected_student_id: initialStudentId || null,
    };
  },
  computed: {
    can_search() {
      return this.valid && /^\d{8}$/.test(this.input_student_id);
    },
    student_id_rules() {
      return [
        (value) => !!value || this.$t("home.student_id_required"),
        (value) =>
          /^\d{8}$/.test(value || "") || this.$t("home.student_id_length"),
      ];
    },
  },
  watch: {
    "$route.query.student_id"(studentId) {
      this.search_student_from_query(studentId);
    },
  },
  mounted() {
    this.search_student_from_query(
      this.$route.query.student_id || get_student_id_from_url()
    );
  },
  methods: {
    keep_only_digits(value) {
      const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
      if (digits !== value) this.input_student_id = digits;
    },
    async search_student() {
      if (!this.$refs.studentForm || !this.$refs.studentForm.validate()) return;

      const studentId = this.input_student_id;
      this.selected_student_id = null;
      await this.$nextTick();
      this.selected_student_id = studentId;
    },
    search_student_from_query(studentId) {
      const normalizedStudentId = normalize_student_id(studentId);
      if (!normalizedStudentId) return;

      this.input_student_id = normalizedStudentId;
      this.selected_student_id = normalizedStudentId;
    },
  },
};
</script>

<style scoped>
.payment-officer-controls {
  min-height: 0;
}
.student-id-search-col {
  max-width: 360px;
}
@media (max-width: 600px) {
  .student-id-search-col {
    max-width: 100%;
  }
}
</style>
